import React from "react";
import { getVendorSettings } from "../../../services/helper";
import { useNavigate } from "react-router-dom";
import { Btn } from "../../../AbstractElements";
import { useDispatch } from "react-redux";
import { openView } from "../../../ReduxToolkit/Reducers/viewReducer";

export default function EODHeader({ closed_at, printLink = null }) {
  const vendor_store_name = getVendorSettings("name");
  const vendor_address = getVendorSettings("vendor_contact_address");
  const vendor_phone = getVendorSettings("vendor_contact_phone");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="text-center mb-4">
      <div className="mb-3 d-flex justify-content-center gap-2 flex-wrap">
        <Btn color="primary" onClick={() => dispatch(openView("reports_eod"))}>
          ← Back to End Day List
        </Btn>
        <a
          href={printLink}
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-info"
        >
          Print
        </a>
      </div>
      <h2>{vendor_store_name}</h2>
      <p>{vendor_address}</p>
      <p>{vendor_phone}</p>
      <h3 className="mt-3">
        End Of Day Report For: {new Date(closed_at).toLocaleString()}
      </h3>
    </div>
  );
}
